
import Vue, { PropType } from "vue";
import { TenantUser } from "@/models";

import TenantUserListItem from "./TenantUserListItem.vue";

export default Vue.extend({
  name: "TenantUserList",

  props: {
    tenantUsers: Array as PropType<Array<TenantUser>>
  },

  components: {
    TenantUserListItem
  }
});
